<template>
  <div>
    <v-row row wrap fill-height class="mx-0" style="border: 1px solid #d0d0d0">
      <!-- Dashboard certificates to do next -->
      <!-- TODO: Update this cards contents and theme -->
      <v-col
        cols="12"
        md="4"
        order-md="2"
        order="1"
        class="pa-0"
        :class="$vuetify.display.smAndDown ? 'border-dashboard-bottom' : ''"
      >
        <div
          class="to-do-next-card-container"
          :style="
            nextStepCardData.todoNextCardThemeDark
              ? 'background-color: #191919;color:#fff'
              : 'background-color: #f7f7f7;color:#191919'
          "
        >
          <img class="to-do-next-pitchfork-icon" :src="pitchforkIcon" alt="asu-pitchfork" />
          <div class="todo-next-card-content text-body-2">
            <div v-if="nextStepCardData.text">{{ nextStepCardData.text }}</div>
            <div
              v-if="nextStepCardData.title"
              :style="$vuetify.display.smAndDown ? 'font-size: 24px' : 'font-size: 32px'"
              class="mt-4 font-weight-bold"
            >
              {{ nextStepCardData.title }}
            </div>
            <v-btn
              v-if="nextStepCardData.ctaButtonText"
              variant="flat"
              rounded
              color="#ffc628"
              class="ma-0 mt-6 text-body-2 font-weight-bold"
              @click="toDoNextCtaClick(nextStepCardData.title, nextStepCardData.ctaButtonText)"
              >{{ nextStepCardData.ctaButtonText }}</v-btn
            >
            <div v-if="nextStepCardData.ctaLinkText">
              <button
                :disabled="nextStepCardData.title === 'It’s time to apply to ASU!'"
                @click="toDoNextCtaLinkClick(nextStepCardData.title, nextStepCardData.ctaLinkText)"
                class="degrees-certificates-view-more mt-6"
                :style="nextStepCardData.todoNextCardThemeDark ? 'color:#fff' : ''"
              >
                {{ nextStepCardData.ctaLinkText }}
              </button>
            </div>
          </div>
        </div>
      </v-col>

      <!-- Combined Row 1 and Row 2 -->
      <v-col v-if="!showDegreesAndCertificates" cols="12" md="8" order-md="1" order="2" class="pa-0 d-flex"
        ><SectionGetStarted
      /></v-col>
      <v-col v-if="showDegreesAndCertificates" cols="12" md="8" order-md="1" order="2" class="pa-0">
        <v-row row wrap class="mx-0">
          <!-- TODO: Bring back progress section after revision of progress section -->
          <v-col v-if="false" class="pa-6" :class="$vuetify.display.smAndDown ? 'border-dashboard-bottom' : ''">
            <div class="headline font-weight-bold">Get ready to enroll</div>

            <div class="text-body-2 text-accelerate-grey-2 mt-2 pb-4">Check your progress</div>
            <v-row row wrap style="margin: 0">
              <v-col cols="12" md="6">
                <div class="align-center justify-center" style="display: flex">
                  <CircleProgressBar
                    :progressText="`${progressProfileCompletion[0].percentage}%`"
                    progressBarTextStyle="color:black;"
                    style="height: 150px; width: 150px"
                    :progressSegments="progressProfileCompletion"
                    :showImage="true"
                  />
                </div>
              </v-col>

              <v-col cols="12" md="6">
                <div class="align-center justify-center" style="display: flex">
                  <div>
                    <div
                      v-for="profileProgress in updatedProfileCompletionProgress"
                      :key="`${profileProgress.text}`"
                      class="text-body-2 text-accelerate-grey-2 my-1"
                    >
                      <v-icon class="mr-2" :color="profileProgress.status ? '#000000' : '#c2c2c2'"
                        >mdi-check-circle</v-icon
                      >
                      {{ profileProgress.text }}
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-col>

          <!-- <TrackYourDegreesCard v-if="trackDegreeProgress === null" @trackDegreeProgressHandler="trackDegreeProgressHandler" /> -->

          <!-- Credit Progress with Toggle -->
          <v-col
            v-if="showDegreesAndCertificates"
            cols="12"
            md="6"
            class="pa-6"
            :class="$vuetify.display.smAndDown ? 'border-dashboard-bottom' : ''"
          >
            <!-- Header -->
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding-bottom: 16px;
                border-bottom: 1px solid #d0d0d0;
                margin-bottom: 24px;
              "
            >
              <span style="font-family: Arial, sans-serif; font-size: 20px; color: #191919">Credit progress</span>
              <button
                style="
                  font-family: Arial, sans-serif;
                  font-size: 12px;
                  color: #8c1d40;
                  text-decoration: underline;
                  background: none;
                  border: none;
                  cursor: pointer;
                  white-space: nowrap;
                "
                @click="goToCourseHistoryPage"
              >
                See full learning history
              </button>
            </div>

            <!-- Pill Toggle (only show when trackAADegree is true) -->
            <div
              v-if="trackAssociateDegrees"
              style="
                display: flex;
                gap: 4px;
                padding: 4px;
                background-color: #e8e8e8;
                border-radius: 100px;
                width: 100%;
                margin-bottom: 24px;
              "
            >
              <button
                style="
                  flex: 1;
                  padding: 4px 0;
                  border: none;
                  border-radius: 100px;
                  font-family: Arial, sans-serif;
                  font-size: 16px;
                  line-height: 24px;
                  letter-spacing: -0.48px;
                  cursor: pointer;
                "
                :style="
                  creditProgressView === 'credits'
                    ? 'background: #fff; font-weight: 700; color: #000'
                    : 'background: transparent; font-weight: 400; color: #484848'
                "
                @click="creditProgressView = 'credits'"
              >
                Total credits
              </button>
              <button
                style="
                  flex: 1;
                  padding: 4px 0;
                  border: none;
                  border-radius: 100px;
                  font-family: Arial, sans-serif;
                  font-size: 16px;
                  line-height: 24px;
                  cursor: pointer;
                "
                :style="
                  creditProgressView === 'degree'
                    ? 'background: #fff; font-weight: 700; color: #000; letter-spacing: -0.48px'
                    : 'background: transparent; font-weight: 400; color: #484848'
                "
                @click="creditProgressView = 'degree'"
              >
                Degree
              </button>
            </div>

            <!-- View: Total credits -->
            <div
              v-if="creditProgressView === 'credits'"
              style="
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 20px;
                width: 242px;
                margin: 0 auto;
              "
            >
              <!-- GPA Circle -->
              <MyCollegeCreditsGpaCircle
                v-if="!creditProgressNoCompleted"
                :gpa="currentGPA"
                style="width: 114px; height: 114px"
              />

              <!-- Calculate GPA button -->
              <button
                v-if="!creditProgressNoCompleted"
                style="
                  width: 100%;
                  padding: 8px 16px;
                  background-color: #ffc627;
                  border: none;
                  border-radius: 25px;
                  font-family: Arial, sans-serif;
                  font-weight: 700;
                  font-size: 14px;
                  color: #191919;
                  cursor: pointer;
                "
                @click="handleCalculateGpaClick"
              >
                Calculate GPA
              </button>

              <!-- Credit rows -->
              <div style="display: flex; flex-direction: column; gap: 12px; width: 100%">
                <div
                  v-for="(row, index) in creditProgressRows"
                  :key="index"
                  style="display: flex; align-items: center; gap: 16px"
                >
                  <img :src="row.icon" alt="" style="width: 24px; height: 24px; flex-shrink: 0" />
                  <div
                    style="display: flex; align-items: center; flex: 1; justify-content: space-between; min-width: 0"
                  >
                    <span
                      style="font-family: Arial, sans-serif; font-size: 14px; line-height: 22px; white-space: nowrap"
                      :style="row.status === 'completed' ? 'color: #191919' : 'color: #484848'"
                    >
                      {{ row.text }}
                    </span>
                    <v-tooltip
                      right
                      color="#484848"
                      max-width="250px"
                      @update:modelValue="(val) => val && handleCreditTooltipClick(row.status)"
                    >
                      <template v-slot:activator="{ props }">
                        <div v-bind="props" style="cursor: pointer; flex-shrink: 0; margin-left: 8px">
                          <img :src="assets.circleInfoRegular" alt="info" style="width: 24px; height: 24px" />
                        </div>
                      </template>
                      <span style="font-size: 14px; color: white">{{ creditProgressTooltips[row.status] }}</span>
                    </v-tooltip>
                  </div>
                </div>
              </div>

              <!-- Info message when no credits completed -->
              <div
                v-if="creditProgressNoCompleted"
                style="
                  display: flex;
                  align-items: flex-start;
                  padding: 8px 16px;
                  background-color: #f6f6f6;
                  border-radius: 4px;
                  gap: 12px;
                  width: 100%;
                "
              >
                <v-icon style="color: #747474; flex-shrink: 0; margin-top: 2px" size="20">mdi-information</v-icon>
                <span style="font-family: Arial, sans-serif; font-size: 14px; color: #747474; line-height: 20px">
                  Once you complete your first course you'll also see a summary of your completed credits and your GPA
                  here.
                </span>
              </div>
            </div>

            <!-- View: Degree -->
            <div
              v-if="creditProgressView === 'degree'"
              style="
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 20px;
                width: 242px;
                margin: 0 auto;
              "
            >
              <!-- Associate degree heading -->
              <div
                class="font-weight-bold"
                style="font-family: Arial, sans-serif; font-size: 16px; color: #191919; text-align: center; width: 100%"
              >
                Associate degree
              </div>

              <!-- Existing CircleProgressBar with multi-segment donut -->
              <CircleProgressBar
                style="height: 150px; width: 150px"
                :progressSegments="degreeDonutSegments.segments"
                :progressText="`${degreeDonutSegments.completedPercentage}%`"
                progressSubText="COMPLETE"
                :showImage="true"
                :showHover="true"
                :dotPositions="[25, 50, 75, 100]"
              />

              <!-- Credit rows -->
              <div style="display: flex; flex-direction: column; gap: 12px; width: 100%">
                <div
                  v-for="(row, index) in degreeCreditProgressRows"
                  :key="index"
                  style="display: flex; align-items: center; gap: 16px"
                >
                  <img :src="row.icon" alt="" style="width: 24px; height: 24px; flex-shrink: 0" />
                  <div
                    style="display: flex; align-items: center; flex: 1; justify-content: space-between; min-width: 0"
                  >
                    <span
                      style="font-family: Arial, sans-serif; font-size: 14px; line-height: 22px; white-space: nowrap"
                      :style="row.status === 'completed' ? 'color: #191919' : 'color: #484848'"
                    >
                      {{ row.text }}
                    </span>
                    <v-tooltip
                      right
                      color="#484848"
                      max-width="250px"
                      @update:modelValue="(val) => val && handleCreditTooltipClick(row.status)"
                    >
                      <template v-slot:activator="{ props }">
                        <div v-bind="props" style="cursor: pointer; flex-shrink: 0; margin-left: 8px">
                          <img :src="assets.circleInfoRegular" alt="info" style="width: 24px; height: 24px" />
                        </div>
                      </template>
                      <span style="font-size: 14px; color: white">{{ creditProgressTooltips[row.status] }}</span>
                    </v-tooltip>
                  </div>
                </div>
              </div>

              <!-- Info message when no credits completed -->
              <div
                v-if="creditProgressNoCompleted"
                style="
                  display: flex;
                  align-items: flex-start;
                  padding: 8px 16px;
                  background-color: #f6f6f6;
                  border-radius: 4px;
                  gap: 12px;
                  width: 100%;
                "
              >
                <v-icon style="color: #747474; flex-shrink: 0; margin-top: 2px" size="20">mdi-information</v-icon>
                <span style="font-family: Arial, sans-serif; font-size: 14px; color: #747474; line-height: 20px">
                  Once you complete your first course you'll also see a summary of your completed credits and your GPA
                  here.
                </span>
              </div>
            </div>
          </v-col>

          <!-- Certificates -->
          <v-col
            v-if="showDegreesAndCertificates"
            cols="12"
            md="6"
            class="pa-6"
            :style="$vuetify.display.smAndDown ? '' : 'border-right: 1px solid #d0d0d0'"
          >
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding-bottom: 16px;
                border-bottom: 1px solid #d0d0d0;
                margin-bottom: 24px;
              "
            >
              <span style="font-family: Arial, sans-serif; font-size: 20px; color: #484848">Certificates</span>
              <button
                class="degrees-certificates-view-more"
                @click="(openModal('certificatesModal'), handleSeeAllClick())"
              >
                See all
              </button>
            </div>
            <!-- Show if any certificate in progress -->
            <!-- TODO: Updated the status according to the certificates status -->
            <div v-if="certificatesProgressStarted">
              <div
                v-for="(certificate, index) in topFourCertificatesData"
                :key="`${index}-${certificate.title}`"
                class="text-body-2 text-accelerate-grey-2"
              >
                <div class="d-flex pb-6">
                  <img
                    :src="getCertificateStatusIcon(certificate.progress, certificate.total)"
                    alt="Certificate status icon"
                    class="mr-2"
                    style="max-width: 32px"
                  />
                  <div class="ml-1 text-body-2">
                    <p class="mb-1 font-weight-bold text-accelerate-grey-1">{{ certificate.certificateName }}</p>
                    <p class="mb-0" v-if="certificateStatus(certificate.progress, certificate.total) === 'completed'">
                      {{ certificate.progress }} credits
                    </p>
                    <p class="mb-0" v-else>{{ certificate.progress }}/{{ certificate.total }} credits</p>
                  </div>
                </div>
              </div>
              <!-- TODO: Add this back in when the certificates are updated -->
              <!-- <div class="px-4 py-2 text-body-2 text-accelerate-grey-2" style="display: flex; align-items: center; background-color: #f6f6f6">
                <v-icon class="mr-3">mdi-information</v-icon>
                <div>Click “See all” to add another certificate goal</div>
              </div> -->
            </div>

            <!-- Show when no certificates in progress -->
            <!-- TODO: Updated the status according to the certificates status -->
            <v-row v-if="!certificatesProgressStarted" align-center justify="center" column>
              <div class="mt-4"><img :src="assets.noCertificatesProgress" alt="" /></div>
              <div class="py-4 px-3 text-caption text-accelerate-grey-2 text-center">
                As you complete these courses and convert them for credit, you make progress towards earning the
                certificates below. Courses added toward your transcript will go toward your degree and can count for
                multiple certificates.
              </div>
              <v-btn
                rounded
                variant="flat"
                dark
                class="mb-4 font-weight-bold"
                style="background-color: #191919; color: #fafafa !important"
                @click="openModal('certificatesModal')"
              >
                View certificates
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <custom-modal
      id="degreesModal_v2"
      v-model="modals['degreesModal_v2']"
      modal-class="custom-modal"
      headerClass="text-h6 font-weight-regular px-6 pt-6"
      body-class="px-6 pb-6"
      footer-class="custom-footer"
      @close="(onModalClose('degreesModal_v2'), resetDegreesPopupModalIndex())"
      @close-modal="(onCustomClose('degreesModal_v2'), resetDegreesPopupModalIndex())"
    >
      <template v-slot:modalHeader>
        <div>My college credits</div>
      </template>
      <template v-slot:modalBody> <DashboardDegreesCollegeCreditsModal_v2 /> </template>
    </custom-modal>

    <custom-modal
      id="certificatesModal"
      v-model="modals['certificatesModal']"
      :headerClass="$vuetify.display.smAndDown ? 'px-4' : 'px-6'"
      :bodyClass="$vuetify.display.smAndDown ? 'px-6 pb-6' : 'px-12 pb-12'"
    >
      <template v-slot:modalBody>
        <div class="border-dashboard-bottom">
          <p class="font-weight-bold certificates-modal-title-text" :class="{ headline: $vuetify.display.smAndDown }">
            Certificates
          </p>
          <p class="mb-4 text-accelerate-grey-1" :class="$vuetify.display.smAndDown ? 'text-body-2' : 'text-body-1'">
            As you complete these courses and convert them for credit, you make progress towards earning the
            certificates below. Courses added toward your transcript will go toward your degree and can count for
            multiple certificates.
          </p>
        </div>

        <!-- Foundations Certificates -->
        <div class="my-4">
          <p class="font-weight-bold text-accelerate-grey-1" :class="{ 'text-body-1': $vuetify.display.smAndDown }">
            Accelerate Certificates
          </p>
          <p class="text-body-2 text-accelerate-grey-2">
            Foundations certificates are designed to provide opportunities for career-aligned degree exploration,
            helping students build fundamental skills before committing to specific programs.
          </p>
        </div>

        <v-row justify="space-between">
          <v-col cols="12" md="6" class="text-body-2 font-weight-bold pa-0" align-self="center"
            >{{ foundationsCertificates.length }} certificates available</v-col
          >

          <v-col
            cols="12"
            md="6"
            class="pa-0"
            :class="$vuetify.display.mdAndUp ? 'text-right' : ''"
            align-self="center"
          >
            <v-menu>
              <template v-slot:activator="{ props }">
                <button v-bind="props" class="text-accelerate-grey-1 font-weight-bold text-caption">
                  Sort by: <span class="font-weight-regular">{{ selectedSort }}</span>
                  <v-icon class="ml-2">mdi-chevron-down</v-icon>
                </button>
              </template>

              <v-list class="text-caption">
                <v-list-item @click="setSortOption('Alphabetical (Asc)')">
                  <v-list-item-title class="text-caption">Alphabetical (Asc)</v-list-item-title>
                </v-list-item>
                <v-list-item @click="setSortOption('Alphabetical (Desc)')">
                  <v-list-item-title class="text-caption">Alphabetical (Desc)</v-list-item-title>
                </v-list-item>
                <v-list-item @click="setSortOption('Credits needed (Asc)')">
                  <v-list-item-title class="text-caption">Credits needed (Asc)</v-list-item-title>
                </v-list-item>
                <v-list-item @click="setSortOption('Credits needed (Desc)')">
                  <v-list-item-title class="text-caption">Credits needed (Desc)</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>

        <div v-for="(certificate, index) in foundationsCertificates" :key="`${index}-${certificate.certificateName}`">
          <CertificateProgressOverviewCard
            :image="certificate.cartificateImg"
            :certificateTitle="certificate.certificateName"
            :certificateTotalCredits="certificate.total"
            :certificateCreditsCompleted="certificate.progress"
            :certificateStatus="certificateStatus(certificate.progress, certificate.total)"
            :certificateUrl="certificate.url"
          />
        </div>

        <!-- Mastery Certificates: New name='Certificates' -->
        <div class="mb-6" :class="$vuetify.display.smAndDown ? 'mt-8' : 'mt-14'">
          <p class="font-weight-bold text-accelerate-grey-1" :class="{ 'text-body-1': $vuetify.display.smAndDown }">
            Certificates
          </p>
          <p class="text-body-2 text-accelerate-grey-2">
            Certificates are designed to give you the skills and credentials that employers value.
          </p>
        </div>

        <div class="text-body-2 font-weight-bold">{{ masteryCertificates.length }} certificates available</div>

        <div v-for="(certificate, index) in masteryCertificates" :key="`${index}-${certificate.certificateName}`">
          <CertificateProgressOverviewCard
            :image="certificate.cartificateImg"
            :certificateTitle="certificate.certificateName"
            :certificateTotalCredits="certificate.total"
            :certificateCreditsCompleted="certificate.progress"
            :certificateStatus="certificateStatus(certificate.progress, certificate.total)"
            :certificateUrl="certificate.url"
          />
        </div>
      </template>
    </custom-modal>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { useUserStore } from '@/stores/user';
import { useCoursesStore } from '@/stores/courses';

import CircleProgressBar from './CircleProgressBar.vue';
import CustomCarousel from './CustomCarousel.vue';
import CustomModal from './CustomModal.vue';
import CertificateProgressOverviewCard from './CertificateProgressOverviewCard.vue';
import DashboardDegreesCollegeCreditsModal_v2 from './DashboardDegreesCollegeCreditsModal_v2.vue';
import SectionGetStarted from './SectionGetStarted.vue';
import CustomToggle from './CustomToggle.vue';
import MyCollegeCreditsGpaCircle from './MyCollegeCreditsGpaCircle.vue';
import { DataLayerMixin } from '../../mixins/dataLayerMixin';
import { Logger } from '../../mixins/logger';

// Import SVG assets
import pitchforkWhite from '@/assets/icons/pitchfork-white.svg';
import pitchforkBlack from '@/assets/icons/pitchfork-black.svg';
import greenCheckCircle from '@/assets/icons/green-check-circle-icon.svg';
import greyInProgressCircle from '@/assets/icons/grey-in-progress-circle-icon.svg';
import noCertificatesProgress from '@/assets/images/no-certificates-progress.svg';
import circleInfoRegular from '@/assets/icons/circle-info-regular.svg';
import circleCheckGreenIcon from '@/assets/icons/circle-check-green.svg';
import circleInProgressIcon from '@/assets/icons/circle-in-progress-my-college-credits.svg';
import circlePendingIcon from '@/assets/icons/circle-pending-my-college-credits.svg';

export default defineComponent({
  mixins: [DataLayerMixin, Logger],

  data() {
    return {
      // Import SVG assets for use in template
      assets: {
        pitchforkWhite,
        pitchforkBlack,
        greenCheckCircle,
        greyInProgressCircle,
        noCertificatesProgress,
        circleInfoRegular
      },
      toDoNextCardData: {
        verifyId: {
          text: 'To do next:',
          title: 'Verify your ID',
          ctaButtonText: 'Get started',
          todoNextCardThemeDark: false
        },
        completeProfile: {
          text: 'To do next:',
          title: 'Complete your profile',
          ctaButtonText: 'Get started',
          todoNextCardThemeDark: false
        },
        continueCourseWork: {
          text: 'To do next:',
          title: 'Continue your coursework',
          ctaLinkText: 'See “my college credits” section',
          todoNextCardThemeDark: false
        },
        applyToASU: {
          text: 'To do next:',
          title: 'It’s time to apply to ASU!',
          ctaButtonText: 'Complete your application',
          ctaLinkText: 'Be sure to login with your ASURITE',
          todoNextCardThemeDark: true
        },
        applicationSubmitted: {
          title: 'Thanks for applying!',
          ctaButtonText: 'Check your application status',
          ctaLinkText: 'Review the info you submitted',
          todoNextCardThemeDark: true
        }
      },

      model: 0,
      modals: {
        degreesModal: false,
        certificatesModal: false,
        degreesModal_v2: false
      },
      progressSegments: [
        { percentage: 10, color: '#498500' },
        { percentage: 30, color: '#484848' },
        { percentage: 30, color: '#a2a09d' }
      ],
      // progressProfileCompletion: [{ percentage: 40 }],
      profileCompletionProgress: [
        {
          text: 'Activate your ASURITE ID',
          status: true
        },
        {
          text: 'Login to your dashboard',
          status: true
        },
        {
          text: 'Verify your ID',
          status: false
        },
        {
          text: 'Complete your profile',
          status: false
        },
        {
          text: 'Sign up for courses',
          status: false
        }
      ],

      certificatedData: [
        {
          certificateName: 'AWS Cloud Computing',
          cartificateImg: 'AWS_Cloud_Computing.svg',
          url: 'https://ulc.asu.edu/explore-courses/certificates/aws-cloud-computing/'
        },
        {
          certificateName: 'Education',
          cartificateImg: 'Education.svg',
          url: 'https://ulc.asu.edu/explore-courses/certificates/google-it/'
        },
        {
          certificateName: 'College Foundations',
          cartificateImg: 'College_Foundations.svg',
          url: 'https://ulc.asu.edu/explore-courses/certificates/college-foundations/'
        },
        {
          certificateName: 'General Business',
          cartificateImg: 'General_Business.svg',
          url: 'https://ulc.asu.edu/explore-courses/certificates/general-business/'
        },
        {
          certificateName: 'Behavioral Sciences',
          cartificateImg: 'Behavioral_Sciences.svg',
          url: 'https://ulc.asu.edu/explore-courses/certificates/behavioral-sciences/'
        },
        {
          certificateName: 'Project Management',
          cartificateImg: 'Project_Management.svg',
          url: 'https://ulc.asu.edu/explore-courses/certificates/project-management/'
        },
        {
          certificateName: 'Google IT Professional',
          cartificateImg: 'Google_IT_Professional.svg',
          url: 'https://ulc.asu.edu/explore-courses/certificates/google-it/'
        },
        {
          certificateName: 'Data Analysis Fundamentals in Business',
          cartificateImg: 'Applied_Business_Data_Analytics_Professional.svg',
          url: 'https://ulc.asu.edu/explore-courses/certificates/abda/'
        },
        {
          certificateName: 'Health Education',
          cartificateImg: 'Health_Education.svg',
          url: 'https://ulc.asu.edu/explore-courses/certificates/healthcare-education/'
        },
        {
          certificateName: 'STEM Foundations',
          cartificateImg: 'STEM_Foundations.svg',
          url: 'https://ulc.asu.edu/explore-courses/certificates/stem-foundations/'
        },
        {
          certificateName: 'Engineering',
          cartificateImg: 'Engineering.svg',
          url: 'https://ulc.asu.edu/explore-courses/certificates/engineering/'
        },
        {
          certificateName: 'Sustainability',
          cartificateImg: 'Sustainability.svg',
          url: 'https://ulc.asu.edu/explore-courses/certificates/sustainability/'
        },
        {
          certificateName: 'Computer Science',
          cartificateImg: 'Computer_Science.svg',
          url: 'https://ulc.asu.edu/explore-courses/certificates/computer-science/'
        }
      ],
      updatedCertificatedData: [],
      selectedSort: 'Credits needed (Desc)',
      selectedView: 'semester',
      options: [
        { label: 'Semester', value: 'semester' },
        { label: 'Degree', value: 'degree' }
      ],
      creditProgressView: 'credits',
      creditProgressIcons: {
        completed: circleCheckGreenIcon,
        inprogress: circleInProgressIcon,
        pending: circlePendingIcon
      },
      creditProgressTooltips: {
        completed: 'Credits that have been completed through ASU and added to your transcript.',
        inprogress: 'Credits from ASU courses you currently have in-progress',
        pending: 'Credits that need to be added to your transcript.'
      },
      creditTooltipTrackingText: {
        completed: 'verified asu credits',
        inprogress: 'credits in progress',
        pending: 'credits pending'
      }
    };
  },

  props: {
    progressCertificates: {
      type: Array,
      default: () => []
    }
  },
  components: {
    CircleProgressBar,
    CustomModal,
    CustomCarousel,
    CertificateProgressOverviewCard,
    DashboardDegreesCollegeCreditsModal_v2,
    CustomToggle,
    SectionGetStarted,
    MyCollegeCreditsGpaCircle
  },

  computed: {
    pitchforkIcon() {
      return this.nextStepCardData.todoNextCardThemeDark ? this.assets.pitchforkWhite : this.assets.pitchforkBlack;
    },

    mappedCertificates() {
      if (!Array.isArray(this.progressCertificates) || !this.progressCertificates.length) {
        return this.certificatedData;
      }

      let sortedData = this.certificatedData.map((cert) => {
        const match = this.progressCertificates.find((item) => item.name === cert.certificateName);
        return match ? { ...cert, ...match } : cert;
      });

      return sortedData.sort((a, b) => {
        switch (this.selectedSort) {
          case 'Alphabetical (Asc)':
            return (a.certificateName || a.name || '').localeCompare(b.certificateName || b.name || '');
          case 'Alphabetical (Desc)':
            return (b.certificateName || b.name || '').localeCompare(a.certificateName || a.name || '');
          case 'Credits needed (Asc)':
            return a.total - a.progress - (b.total - b.progress);
          case 'Credits needed (Desc)':
            return b.total - b.progress - (a.total - a.progress);
          default:
            return 0;
        }
      });
    },

    certificatesProgressStarted() {
      return (
        Array.isArray(this.progressCertificates) && this.progressCertificates.some((cert) => Number(cert.progress) > 0)
      );
    },

    foundationsCertificates() {
      return this.mappedCertificates.filter((cert) => cert.type === 'Accelerate - Foundations');
    },

    masteryCertificates() {
      return this.mappedCertificates.filter((cert) => cert.type === 'Accelerate - Mastery');
    },

    idVerified() {
      const userStore = useUserStore();
      return userStore.apis.learnerData._idVerify;
    },

    trackDegreeProgress() {
      const userStore = useUserStore();
      return userStore.apis.learnerData.track_degree_progress;
    },

    enrollmentsLength() {
      const coursesStore = useCoursesStore();
      return coursesStore.enrollments.length;
    },

    profileIncomplete() {
      const userStore = useUserStore();
      return this.shouldCheckIfProfileIncomplete(userStore.apis.learnerData);
    },

    showDegreesAndCertificates() {
      const coursesStore = useCoursesStore();
      return coursesStore.showLearnerProgress;
    },

    updatedProfileCompletionProgress() {
      return this.profileCompletionProgress.map((step) => {
        if (step.text === 'Verify your ID') return { ...step, status: !!this.idVerified };
        if (step.text === 'Complete your profile') return { ...step, status: !this.profileIncomplete };
        if (step.text === 'Sign up for courses') return { ...step, status: this.showDegreesAndCertificates };
        return step;
      });
    },

    learnerUGApplicationStatus() {
      const coursesStore = useCoursesStore();
      return coursesStore.learnerUGApplicationStatus || '';
    },

    nextStepCardData() {
      if (!this.idVerified) return this.toDoNextCardData.verifyId;
      if (this.profileIncomplete) return this.toDoNextCardData.completeProfile;

      // if (this.enrollmentsLength === 0) return this.toDoNextCardData.continueCourseWork; // No enrolled courses

      return this.calculateNextCardStep();
    },

    progressProfileCompletion() {
      let completion = 40;
      if (this.idVerified) completion += 20;
      if (!this.profileIncomplete) completion += 20;
      if (this.enrollmentsLength > 0) completion += 20;
      return [{ percentage: completion }];
    },

    associateDegreesData() {
      const coursesStore = useCoursesStore();
      return coursesStore.degreeProgress || {};
    },

    bachelorsDegreesData() {
      const coursesStore = useCoursesStore();
      return coursesStore.collegeCredits || {};
    },

    bachelorsDegreesprogressSegments() {
      const {
        creditsCompleted = 0,
        creditsInProgress = 0,
        creditsPending = 0,
        totalCredits = 120
      } = this.bachelorsDegreesData;

      const toPercentage = (credits) => (totalCredits > 0 ? Math.round((credits / totalCredits) * 100) : 0);

      return {
        segments: [
          { percentage: toPercentage(creditsCompleted), color: '#498500' },
          { percentage: toPercentage(creditsInProgress), color: '#484848' },
          { percentage: toPercentage(creditsPending), color: '#a2a09d' }
        ],
        totalCreditsCompleted: creditsCompleted,
        totalCredits,
        totalProgress: toPercentage(creditsCompleted + creditsInProgress + creditsPending)
      };
    },

    bachelorsModalContents() {
      const {
        creditsCompleted = 0,
        creditsInProgress = 0,
        creditsPending = 0,
        totalCredits = 120
      } = this.bachelorsDegreesData;

      const toPercentage = (credits) => (totalCredits > 0 ? Math.round((credits / totalCredits) * 100) : 0);

      return [
        {
          text: 'Verified ASU Credits',
          completedCredits: creditsCompleted,
          totalCredits,
          color: '#498500',
          percentage: toPercentage(creditsCompleted),
          tooltipMessage: 'Credits that have been completed through ASU.'
        },
        {
          text: 'In Progress Credits',
          completedCredits: creditsInProgress,
          totalCredits,
          color: '#484848',
          percentage: toPercentage(creditsInProgress),
          tooltipMessage: 'Credits from ASU courses you currently have in-progress'
        },
        {
          text: 'Credits Pending',
          completedCredits: creditsPending,
          totalCredits,
          color: '#a2a09d',
          percentage: toPercentage(creditsPending),
          tooltipMessage: 'Credits that need to be added to your transcript.'
        }
      ];
    },
    topFourCertificatesData() {
      if (!Array.isArray(this.progressCertificates) || !this.progressCertificates.length) {
        return [];
      }

      let sortedData = this.certificatedData.map((cert) => {
        const match = this.progressCertificates.find((item) => item.name === cert.certificateName);
        return match ? { ...cert, ...match } : cert;
      });

      sortedData = sortedData.filter((cert) => cert.progress > 0);

      // Sort Logic
      sortedData.sort((a, b) => {
        const progressA = a.progress / a.total;
        const progressB = b.progress / b.total;

        // Move fully completed certificates to the end if there are in-progress ones
        const isACompleted = a.progress === a.total;
        const isBCompleted = b.progress === b.total;

        if (isACompleted && !isBCompleted) return 1;
        if (!isACompleted && isBCompleted) return -1;

        // Sort by progress percentage descending
        return progressB - progressA;
      });

      // Cap to top 4
      return sortedData.slice(0, 4);
    },
    latestSemesterProgress() {
      const coursesStore = useCoursesStore();
      const semesters = coursesStore.semesterYearProgress && coursesStore.semesterYearProgress.semesters;
      return Array.isArray(semesters) && semesters.length > 0 ? semesters[0] : {};
    },
    latestSemesterProgressBarData() {
      // Get the latest semester from store
      const coursesStore = useCoursesStore();
      const semesters = coursesStore.semesterYearProgress && coursesStore.semesterYearProgress.semesters;
      if (!Array.isArray(semesters) || semesters.length === 0) return { segments: [], percentage: 0 };
      const latest = semesters[0];
      // Map to CircleProgressBar format
      return {
        segments: [{ percentage: latest.percentage, color: '#498500' }],
        percentage: latest.percentage
      };
    },
    estimatedSavings() {
      const coursesStore = useCoursesStore();
      return coursesStore.estimatedSavings;
    },
    hasEstimatedCost() {
      const { estimatedCost = {} } = this.estimatedSavings || {};
      return estimatedCost.min && estimatedCost.max;
    },
    formattedEstimatedCost() {
      const { estimatedCost = {}, totalCost = 0 } = this.estimatedSavings || {};
      const { min, max } = estimatedCost;

      if (min == null && max == null) return '-';

      const minCost = min != null ? `$${this.toK(min - totalCost)}` : '-';
      const maxCost = max != null ? `$${this.toK(max - totalCost)}` : '-';

      return `${minCost} – ${maxCost}`;
    },
    formattedEstimatedTuition() {
      const { estimatedCost = {} } = this.estimatedSavings || {};
      const { min, max } = estimatedCost;

      if (min == null && max == null) return '-';

      const minTuition = min != null ? `$${this.toK(min)}` : '-';
      const maxTuition = max != null ? `$${this.toK(max)}` : '-';

      return `${minTuition} – ${maxTuition}`;
    },
    bachelorsCreditsCardMessage() {
      const credits = this.bachelorsDegreesData.creditsCompleted || 0;
      // Define ranges and messages
      if (credits === 0) {
        return {
          title: 'Your adventure starts now!',
          body: 'Add completed courses to your transcript to earn college credits'
        };
      } else if (credits > 0 && credits < 4) {
        return {
          title: `First milestone reached!`,
          body: `With these ${credits} credits, you’ve saved ${this.formattedEstimatedCost}. Great start!`
        };
      } else if (credits >= 4 && credits < 7) {
        return {
          title: `Building momentum`,
          body: `${credits} credits done. Keep stacking those wins!`
        };
      } else if (credits >= 7 && credits < 10) {
        return {
          title: `Almost to double digits!`,
          body: `You’ve earned ${credits} credits. Keep pushing!`
        };
      } else if (credits >= 10 && credits < 15) {
        return {
          title: `Double digit college credits!?`,
          body: `Your Estimated Savings are ${this.formattedEstimatedCost}!`
        };
      } else if (credits == 15) {
        return {
          title: `That’s one semester!`,
          body: `With 15 credits, you’ve completed the equivalent of one semester of college!`
        };
      } else {
        return {
          title: `Great Work! Keep Going!`,
          body: `You have completed ${credits} credits towards your degree. Your estimated savings is ${this.formattedEstimatedCost}`
        };
      }
    },
    trackAssociateDegrees() {
      const userStore = useUserStore();
      return userStore.apis.learnerData._trackAADegree;
    },
    creditProgressRows() {
      const { creditsCompleted = 0, creditsInProgress = 0, creditsPending = 0 } = this.bachelorsDegreesData;
      return [
        {
          status: 'completed',
          icon: this.creditProgressIcons.completed,
          text: `${creditsCompleted} verified ASU credits`
        },
        {
          status: 'inprogress',
          icon: this.creditProgressIcons.inprogress,
          text: `${creditsInProgress} credits in-progress`
        },
        {
          status: 'pending',
          icon: this.creditProgressIcons.pending,
          text: `${creditsPending} credits pending`
        }
      ];
    },
    degreeCreditProgressRows() {
      const total = this.associateDegreesData.totalCredits || 60;
      const { creditsCompleted = 0, creditsInProgress = 0, creditsPending = 0 } = this.bachelorsDegreesData;
      return [
        {
          status: 'completed',
          icon: this.creditProgressIcons.completed,
          text: `${creditsCompleted}/${total} verified ASU credits`
        },
        {
          status: 'inprogress',
          icon: this.creditProgressIcons.inprogress,
          text: `${creditsInProgress}/${total} credits in-progress`
        },
        {
          status: 'pending',
          icon: this.creditProgressIcons.pending,
          text: `${creditsPending}/${total} credits pending`
        }
      ];
    },
    degreeDonutSegments() {
      const total = this.associateDegreesData.totalCredits || 60;
      const { creditsCompleted = 0, creditsInProgress = 0, creditsPending = 0 } = this.bachelorsDegreesData;
      const toPercentage = (credits) => (total > 0 ? Math.round((credits / total) * 100) : 0);
      return {
        segments: [
          { percentage: toPercentage(creditsCompleted), color: '#498500' },
          { percentage: toPercentage(creditsInProgress), color: '#484848' },
          { percentage: toPercentage(creditsPending), color: '#a2a09d' }
        ],
        completedPercentage: toPercentage(creditsCompleted)
      };
    },
    creditProgressNoCompleted() {
      const { creditsPending = 0, creditsCompleted = 0 } = this.bachelorsDegreesData;
      return creditsPending + creditsCompleted === 0;
    },
    currentGPA() {
      const userStore = useUserStore();
      let num = userStore.apis.learnerData._currentGPA;
      return Number.parseFloat(num).toFixed(2);
    }
  },

  methods: {
    getCertificateStatusIcon(progress, total) {
      return this.certificateStatus(progress, total) === 'completed'
        ? this.assets.greenCheckCircle
        : this.assets.greyInProgressCircle;
    },

    async trackDegreeProgressHandler(track) {
      try {
        this.$conn.patchLearnersInfo({
          track_degree_progress: track
        });
        this.logInfo('trackDegreeProgressHandler patched info');
      } catch (error) {
        this.logError('trackDegreeProgressHandler ', error);
      }
    },
    openModal(id) {
      this.modals[id] = true;
    },
    onModalClose(id) {
      if (id === 'degreesModal') {
        this.asuoDataLayerClick('accelerateDashboard', '11', { section: 'credit progress', text: 'see details' });
      } else if (id === 'certificatesModal') {
        this.asuoDataLayerClick('accelerateDashboard', '11', { section: 'certificates', text: 'see all' });
      }
    },
    onCustomClose(id) {
      if (id === 'degreesModal') {
        this.asuoDataLayerClick('accelerateDashboard', '11', { section: 'credit progress', text: 'see details' });
      } else if (id === 'certificatesModal') {
        this.asuoDataLayerClick('accelerateDashboard', '11', { section: 'certificates', text: 'see all' });
      }
    },

    handleSeeDetailsClick() {
      this.asuoDataLayerClick('accelerateDashboard', '10', { section: 'credit progress', text: 'see details' });
    },
    handleSeeAllClick() {
      this.asuoDataLayerClick('accelerateDashboard', '10', { section: 'certificates', text: 'see all' });
    },
    shouldCheckIfProfileIncomplete(learnerProfileData) {
      if (!learnerProfileData) return true;
      const requiredFields = [
        '_gender',
        '_pronoun',
        '_ethnicity',
        '_householdIncome',
        '_learnersIntent',
        '_emailId',
        '_birthDate',
        '_notificationsEmail',
        '_phoneNumber',
        '_highSchoolExpectedGraduationDate'
      ];
      return requiredFields.some((field) => !(learnerProfileData[field] || '').trim());
    },
    calculateNextCardStep() {
      // [applicationSubmitted || applyToASU || continueCourseWork]
      //  Check for enrollment and application status and return the response based on these status
      if (this.learnerUGApplicationStatus === 'ELIGIBLE') return this.toDoNextCardData.applyToASU;
      if (this.learnerUGApplicationStatus === 'COMPLETED' || this.learnerUGApplicationStatus === 'IN_PROGRESS')
        return this.toDoNextCardData.applicationSubmitted;

      return this.toDoNextCardData.continueCourseWork;
    },
    toDoNextCtaClick(currentStep, ctaButtonText) {
      if (currentStep === 'Verify your ID') {
        this.asuoDataLayerClick('accelerateDashboard', '1', {
          section: currentStep.toLowerCase(),
          text: ctaButtonText.toLowerCase()
        });
        this.$router.push('/id-verification');
        return;
      }
      if (currentStep === 'Complete your profile') {
        this.asuoDataLayerClick('accelerateDashboard', '1', {
          section: currentStep.toLowerCase(),
          text: ctaButtonText.toLowerCase()
        });
        this.$router.push('/profile');
        return;
      }
      // return this.$router.push('/profile');
      if (currentStep === 'It’s time to apply to ASU!') {
        this.asuoDataLayerClick('accelerateDashboard', '1', {
          section: currentStep.toLowerCase(),
          text: ctaButtonText.toLowerCase()
        });
        window.open(import.meta.env.VITE_UG_APPLICATION_SITE_URL, '_blank');
        return;
      }

      if (currentStep === 'Thanks for applying!') {
        this.asuoDataLayerClick('accelerateDashboard', '1', {
          section: currentStep.toLowerCase(),
          text: ctaButtonText.toLowerCase()
        });
        window.open(import.meta.env.VITE_UG_APPLICATION_SITE_URL, '_blank');
        return;
      }
    },
    toDoNextCtaLinkClick(currentStep, ctaLinkText) {
      if (currentStep === 'Continue your coursework') {
        this.asuoDataLayerClick('accelerateDashboard', '1', {
          section: currentStep.toLowerCase(),
          text: ctaLinkText.toLowerCase()
        });
        const element = document.getElementById('credits');
        if (element) {
          const offset = 70;
          window.scrollTo({ top: element.offsetTop - offset, behavior: 'smooth' });
        }
        return;
      }
      if (currentStep === 'Thanks for applying!') {
        this.asuoDataLayerClick('accelerateDashboard', '1', {
          section: currentStep.toLowerCase(),
          text: ctaLinkText.toLowerCase()
        });
        window.open(import.meta.env.VITE_UG_APPLICATION_SITE_URL, '_blank');
        return;
      }
    },
    certificateStatus(inprogress, total) {
      return inprogress === 0 ? 'open' : inprogress === total ? 'completed' : 'inprogress';
    },
    setSortOption(option) {
      this.selectedSort = option;
      this.asuoDataLayerClick('accelerateDashboard', '22', { text: option.toLowerCase() });
    },
    openDegreesModal() {
      this.openModal('degreesModal');
    },
    setPopupModalIndex(e) {
      this.model = e ? e : 0;
    },
    resetDegreesPopupModalIndex() {
      this.model = 0;
      this.asuoDataLayerClick('accelerateDashboard', '20');
    },
    openCoursesModal() {
      this.asuoDataLayerClick('accelerateDashboard', '12');
      const enrollmentsModalButton = document.getElementById('enrollmentsModal');
      if (enrollmentsModalButton) {
        enrollmentsModalButton.click();
      }
    },
    toK(value) {
      return value >= 1000 ? (value / 1000).toFixed(1) + 'K' : value.toString();
    },
    handleCalculateGpaClick() {
      this.asuoDataLayerClick('accelerateDashboard', '32');
      this.$router.push('/courses-history');
    },
    handleCreditTooltipClick(status) {
      this.asuoDataLayerClick('accelerateDashboard', '33', { text: this.creditTooltipTrackingText[status] });
    },
    goToCourseHistoryPage() {
      this.asuoDataLayerClick('accelerateDashboard', '14');
      this.$router.push('/courses-history');
    }
  }
});
</script>

<style lang="scss" scoped>
.no-shadow {
  border: 1px solid #d0d0d0;
  box-shadow: none !important;
  background: #e8e8e8;
}
.custom-header {
  margin: 50px;
}
.degrees-certificates-view-more {
  color: #8c1d40;
  font-size: 12px;
  text-decoration-line: underline;
}
.border-dashboard-bottom {
  border-bottom: 1px solid #d0d0d0;
}
.circle-btn {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid #d0d0d0;
  background-color: #f0f0f0;
  display: flex;
  justify-content: center;
  align-items: center;
  transition:
    background-color 0.3s ease,
    transform 0.2s ease;
}

.circle-btn:hover {
  background-color: #d0d0d0;
}

.circle-btn i {
  color: #333;
  font-size: 16px;
}
.certificates-modal-title-text {
  font-size: 30px;
}

.to-do-next-card-container {
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
}
.to-do-next-pitchfork-icon {
  position: absolute;
  top: 32px;
  right: 32px;
  width: 32px;
}
.todo-next-card-content {
  padding: 32px 32px;
  max-width: 90%;
}
@media (max-width: 960px) {
  .todo-next-card-content {
    padding: 24px 24px;
  }
  .to-do-next-pitchfork-icon {
    top: 24px;
    right: 24px;
    width: 24px;
  }
}
.v-menu__content.theme--light {
  border-radius: 0px !important;
  border: 1px solid #d3d3d3;
}
.progressbar-circle-pointer {
  cursor: pointer;
}
.tooltip-text {
  font-size: 14px;
  color: white;
  text-align: left;
}
</style>
<style>
.v-window__container {
  height: auto !important;
}
.v-responsive.v-image.v-carousel__item {
  height: auto !important;
}
</style>
